import { all, call, fork, put, takeLatest, take } from "redux-saga/effects";
import request from "../util/request";

import {
    FETCH_USER_DETAILS,
    FETCH_DEVICES_LIST,
    UPDATE_USER_DETAILS,
    FETCH_AVAILABLE_DEVICES,
    FETCH_USER_COUNTRIES,
    GET_LIST_OF_SPECIALISATION,
    DEVICE_OPERATION,
    FETCH_DEVICE_HISTORY,
    FETCH_AVAILABLE_DEVICES_DATES,
    FETCH_FUTURE_ALLOCATIONS,
    CANCEL_FUTURE_ALLOCATIONS,
    FETCH_LIVE_DEVICES,
    RESET_PATIENT_PASSWORD,
    DEPLOY_DEVICE_IN_PAST_DATE,
} from "constants/ActionTypes";

import {
    fetch_devices_list_success,
    fetch_devices_list_failed,
    fetch_user_details as fetch_user_details_action,
    fetch_user_details_success,
    fetch_user_details_failed,
    update_user_info_success,
    update_user_info_failed,
    fetch_available_devices_success,
    fetch_available_devices_failed,
    fetch_user_countries_success,
    fetch_user_countries_failed,
    get_list_of_specialisation_success,
    get_list_of_specialisation_failed,
    device_operation_success,
    device_operation_failed,

    deploy_device_in_past_date_success,
    deploy_device_in_past_date_failed,

    fetch_device_history_success,
    fetch_device_history_failed,

    fetch_available_devices_dates_success,
    fetch_available_devices_dates_failed,

    fetch_future_allocations_success,
    fetch_future_allocations_failed,

    cancel_future_allocations_success,
    cancel_future_allocations_failed,

    fetch_live_devices_success,
    fetch_live_devices_failed,

    reset_patient_password_success,
    reset_patient_password_failed,
} from "actions/user";

import {
    fetch_patients as fetch_patient_action,
    fetch_patient_data
} from "actions/patients";

const takeLeading = (patternOrChannel, saga, ...args) => fork(function* () {
    while (true) {
        const action = yield take(patternOrChannel);
        yield call(saga, ...args.concat(action));
    }
})

const get_user_details_request = async () =>
    // payload
    await request(
        {
            path: "/user"
        },
        false
    )
        .then(user_details => user_details)
        .catch(error => error);

const get_devices_list_request = async () =>
    // payload
    await request(
        {
            path: ""
        },
        false
    )
        .then(user_details => user_details)
        .catch(error => error);

function* reset_patient_password_saga({ payload }) {
    try {
        const response = yield call(request, {
            path: "/physician/reset-patient-password",
            method: "POST",
            body: JSON.stringify(payload)
        });
        if (response.status === 200) {
            yield put(reset_patient_password_success(response))
        } else {
            yield put(reset_patient_password_failed({
                message: response.message
            }))
        }
    } catch (error) {
        yield put(reset_patient_password_failed({
            error: error.message
        }))
    }
}

function* update_user_saga({ payload }) {
    try {
        let token_required = false;
        let multipart = true;
        const response = yield call(request, {
            path: "/update-user-info",
            method: "POST",
            body: payload
        }, token_required, multipart);
        if (response.status === 200 && response.message.includes('User details and Password updated successfully')) {  //User details and Password updated successfully , User Not update successfully
            yield put(update_user_info_success(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 200 && response.message.includes('No password update but User Details updated successfully')) {  //No password update but User Details updated successfully, User Not update successfully
            yield put(update_user_info_success(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 200 && response.message.includes('User Not update successfully')) {  //User Not update successfully
            yield put(update_user_info_success(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 200) {
            yield put(update_user_info_success(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 401 && response.message.includes('Repeated secondary')) { //Repeated secondary email
            yield put(update_user_info_failed(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 401 && response.message.includes('User details updated but password not updated due to mismatched Current Password')) { // User details updated but password not updated due to mismatched Current Password
            yield put(update_user_info_failed(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 401) {
            yield put(update_user_info_failed(response));
            yield put(fetch_user_details_action({}))
        } else if (response.status === 403 && response.message.includes('You are not allowed to update user details')) {  // You are not allowed to update user details, only primary user can update details
            yield put(update_user_info_failed(response));
        } else if (response.status === 403) {
            yield put(update_user_info_failed(response));
        }
        else {
            yield put(update_user_info_failed(response.message));
        }
    } catch (error) {
        yield put(update_user_info_failed(error));
    }
}

function* get_user_details_saga({ payload }) {
    try {
        const response = yield call(get_user_details_request, payload);
        const { data = {} } = response;

        // console.log(response)

        if (response.status === 200) {
            yield put(fetch_user_details_success(data));
            localStorage.setItem('country', data.user_details.country)
        } else if (response.statusCode === 401) {
            yield put(fetch_user_details_failed(response.message));
        }
    } catch (error) {
        yield put(fetch_user_details_failed(error));
    }
}

function* get_devices_list_saga({ payload }) {
    try {
        const response = yield call(get_devices_list_request, payload);
        const { data = {} } = response;

        if (response.status === 200) {
            yield put(fetch_devices_list_success(data));
        } else if (response.statusCode === 401) {
            yield put(fetch_devices_list_failed(response.message));
        }
    } catch (error) {
        console.error(error);
        yield put(fetch_user_details_failed(error));
    }
}

function* fetch_available_devices_saga({ payload }) {
    try {
        const { allocation_time, deallocation_time } = payload;
        const response = yield call(request, {
            path: `/physician/available-devices?allocation_time=${allocation_time}&deallocation_time=${deallocation_time}`,
            method: "GET"
        });

        const { data = {} } = response;

        if (response.status === 200) {
            yield put(fetch_available_devices_success(data));
        } else if (response.statusCode === 401) {
            yield put(fetch_available_devices_failed(response.message));
        }
    } catch (error) {
        console.error(error);
        yield put(fetch_available_devices_failed(error));
    }
}

function* fetch_user_countries_saga() {
    try {
        const response = yield call(request, {
            path: `/countries`,
            method: "GET"
        });

        if (response.status === 200) {
            yield put(fetch_user_countries_success(response.data));
        } else {
            yield put(fetch_user_countries_failed());
        }
    } catch (error) {
        console.error(error);
    }
}

function* get_list_of_specialisation_saga() {
    try {
        const response = yield call(request, {
            path: `/physician/specialisations`,
            method: "GET"
        });

        if (response.status === 200) {
            yield put(get_list_of_specialisation_success(response.data));
        } else {
            yield put(get_list_of_specialisation_failed());
        }
    } catch (error) {
        console.error(error);
    }
}

function* device_operation_saga({ payload }) {
    try {
        const response = yield call(request, {
            path: `/device/device-operation`,
            method: "POST",
            body: JSON.stringify(payload)
        });

        if (response && response.status === 200) {
            yield put(device_operation_success(response));
            if (response.message.indexOf("success") > 0) {
                yield put(fetch_user_details_action({}))
                const { get_patients, get_patients_details } = payload;
                if (get_patients === 1) {
                    yield put(fetch_patient_action());
                } else if (get_patients_details) {
                    yield put(fetch_patient_data(payload.patient_id))
                }
            }
        } else {
            yield put(device_operation_failed(response));
        }
    } catch (error) {
        console.error(error);
        yield put(device_operation_failed());
    }
}

function* deploy_device_in_past_date_saga({ payload }) {
    try {
        const response = yield call(request, {
            path: `/device/deploy-device-in-past-date`,
            method: "POST",
            body: JSON.stringify(payload)
        });

        if (response && response.status === 200) {
            yield put(deploy_device_in_past_date_success(response));
        } else {
            yield put(deploy_device_in_past_date_failed());
        }
    } catch (error) {
        console.error(error);
        yield put(deploy_device_in_past_date_failed());
    }
}

function* fetch_device_history_saga({ payload }) {
    try {
        const response = yield call(request, {
            path: `/device/device-history`,
            method: "POST",
            body: JSON.stringify(payload)
        });

        if (response && response.status === 200) {
            yield put(fetch_device_history_success(response));
        } else {
            yield put(fetch_device_history_failed());
        }
    } catch (error) {
        console.error(error);
        yield put(fetch_device_history_failed());
    }
}

function* fetch_available_devices_dates_saga() {
    try {
        const response = yield call(request, {
            path: `/physician/available-devices-dates`,
            method: "GET",
        });

        if (response && response.status === 200) {
            yield put(fetch_available_devices_dates_success(response));
        } else {
            yield put(fetch_available_devices_dates_failed());
        }
    } catch (error) {
        console.error(error);
        yield put(fetch_device_history_failed());
    }
}

function* fetch_future_allocations_saga({ payload }) {
    try {
        const { device_id } = payload;

        const response = yield call(request, {
            path: `/device/future-allocations`,
            method: "POST",
            body: JSON.stringify({ device_id: device_id })
        });

        if (response && response.status === 200) {
            yield put(fetch_future_allocations_success(response));
        } else {
            yield put(fetch_future_allocations_failed());
        }
    } catch (error) {
        // console.error(error);
        yield put(fetch_future_allocations_failed());
    }
}

function* cancel_future_allocations_saga({ payload }) {
    try {
        const { get_patients, device_id } = payload;

        const response = yield call(request, {
            path: `/device/cancel-future-allocations`,
            method: "POST",
            body: JSON.stringify({ device_id: device_id })
        });

        if (response && response.status === 200) {
            yield put(cancel_future_allocations_success(response));
            if (get_patients === 1) {
                yield put(fetch_patient_action());
            }
        } else {
            yield put(cancel_future_allocations_failed());
        }
    } catch (error) {
        yield put(cancel_future_allocations_failed());
    }
}

function* fetch_live_devices_saga({ payload }) {
    try {
        const response = yield call(request, {
            path: `/device/live-devices${payload ? '?user_ids=' + payload : ''}`,
            method: "GET",
        });

        if (response && response.status === 200) {
            yield put(fetch_live_devices_success(response));
        } else {
            yield put(fetch_live_devices_failed());
        }
    } catch (error) {
        yield put(fetch_live_devices_failed());
    }
}

export function* fetch_live_devices() {
    yield takeLatest(FETCH_LIVE_DEVICES, fetch_live_devices_saga);
}

export function* fetch_future_allocations() {
    yield takeLatest(FETCH_FUTURE_ALLOCATIONS, fetch_future_allocations_saga);
}

export function* cancel_future_allocations() {
    yield takeLatest(CANCEL_FUTURE_ALLOCATIONS, cancel_future_allocations_saga);
}

export function* fetch_available_devices_dates() {
    yield takeLatest(FETCH_AVAILABLE_DEVICES_DATES, fetch_available_devices_dates_saga);
}

export function* device_operation() {

    yield takeLeading(DEVICE_OPERATION, device_operation_saga);
}

export function* deploy_device_in_past_date() {
    yield takeLatest(DEPLOY_DEVICE_IN_PAST_DATE, deploy_device_in_past_date_saga);
}

export function* device_history() {
    yield takeLatest(FETCH_DEVICE_HISTORY, fetch_device_history_saga);
}

export function* fetch_available_devices() {
    yield takeLatest(FETCH_AVAILABLE_DEVICES, fetch_available_devices_saga);
}

export function* get_user_details() {
    yield takeLatest(FETCH_USER_DETAILS, get_user_details_saga);
}
export function* get_devices_list() {
    yield takeLatest(FETCH_DEVICES_LIST, get_devices_list_saga);
}
export function* update_user_details() {
    yield takeLatest(UPDATE_USER_DETAILS, update_user_saga);
}

export function* fetch_user_countries() {
    yield takeLatest(FETCH_USER_COUNTRIES, fetch_user_countries_saga);
}

export function* get_list_of_specialisation() {
    yield takeLatest(GET_LIST_OF_SPECIALISATION, get_list_of_specialisation_saga);
}

export function* reset_patient_password() {
    yield takeLatest(RESET_PATIENT_PASSWORD, reset_patient_password_saga)
}

export default function* rootSaga() {
    yield all([
        fork(reset_patient_password),
        fork(get_user_details),
        fork(get_devices_list),
        fork(update_user_details),
        fork(fetch_available_devices),
        fork(fetch_user_countries),
        fork(get_list_of_specialisation),
        fork(device_operation),
        fork(deploy_device_in_past_date),
        fork(device_history),
        fork(fetch_available_devices_dates),
        fork(fetch_future_allocations),
        fork(cancel_future_allocations),
        fork(fetch_live_devices),
    ]);
}
